import { ToolbarMaskRegion } from '@editor/assets/icons'
import { EDITOR_TOOLS, EDITOR_TOOLS_LABELS, ProductTypes } from '@editor/config/constants'
import { CursorState } from '@editor/config/constants/cursor'
import { EditorTool, ToolbarCategory } from '@editor/interfaces/editor'
import { UserInfo } from '@editor/interfaces/interfaces'

import useEditor from './hooks/useEditor'
import useMainCanvas from './hooks/useMainCanvas'

const MaskPCD: EditorTool = {
  key: EDITOR_TOOLS.PCD_TRIM_CUBOID,
  cursor: CursorState.CROSSHAIR,
  authCheck: (userProfile: UserInfo | null, isAllowedToModify: boolean) =>
    ((userProfile?.owned_products.includes(ProductTypes.Hatsuly) ||
      userProfile?.owned_products.includes(ProductTypes.Markly)) &&
      isAllowedToModify) ||
    false,
  toolbar: {
    icon: <ToolbarMaskRegion size="50%" />,
    label: EDITOR_TOOLS_LABELS.PCD_TRIM_CUBOID,
    category: ToolbarCategory.Manipulate,
  },
  hooks: {
    useEditor,
    useMainCanvas,
  },
  config: {
    additionalToolbars: {
      cuboidControls: true,
    },
    anchor: {
      notPlaceableOnObjects: true,
    },
  },
}

export default MaskPCD
